import { styled } from '@mui/material/styles';
import { Button, Checkbox, Typography } from '@mui/material';

export const SecondaryCheckbox = theme =>
  styled(Checkbox)({
    color: theme.tertiary,
    '&.Mui-checked': {
      color: theme.tertiary,
    },
  });

export const StyledButton = theme =>
  styled(Button)({
    border: `2px solid ${theme.primary}`,
    boxShadow: '0px 4px 6px #00000026',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textDecoration: 'none',
    height: '50px',
    color: theme.text1,
    backgroundColor: theme.primary,
    textTransform: 'none',
    width: '100%',
    maxWidth: '130px',
    fontSize: '18px',
    fontFamily: 'Open Sans',
    marginTop: '1rem',
    '&:hover': {
      backgroundColor: theme.primary,
      color: theme.text1,
    },
    '&:disabled': {
      color: 'black',
      backgroundColor: '#FFFFFF',
      border: '2px solid #000',
      boxShadow: '0px 4px 6px #00000026',
    },
    [theme.breakpoints.down('sm')]: {
      height: '40px',
      fontSize: '16px',
    },
  });

export const AirlineLabel = () =>
  styled(Typography)({
    fontFamily: 'Open Sans',
    fontSize: '10px',
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 600,
    textTransform: 'capitalize',
  });

export const AirlineIcon = theme =>
  styled('img')({
    height: '35px',
    marginRight: '4px',
    [theme.breakpoints.down('sm')]: {
      height: '20px',
    },
  });
